import { useParams } from 'react-router-dom'

import { useDistributionGetApi } from '@/common/api/modules/recommendationDistribution'
import { useSiteId } from '@/common/app/site'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import RecommendationDistributionEditPage from '@/components/container/page/site/recommend/distribution/RecommendationDistributionEditPage'

const RecommendationDistributionUpdatePage = () => {
  const siteId = useSiteId()
  const { distributionId } = useParams()

  const { data, error, mutate } = useDistributionGetApi({
    siteId,
    distributionId: Number(distributionId)
  })

  return (
    <DetailPageLoader error={error} data={data}>
      <RecommendationDistributionEditPage distribution={data} onRefetch={() => mutate()} />
    </DetailPageLoader>
  )
}

export default RecommendationDistributionUpdatePage
